import { Component, Input} from '@angular/core';
import { FormGroup } from '@angular/forms';
// text,email,tel,textarea,password,
@Component({
    selector: 'textbox',
    template: `
      <div [formGroup]="form">
      <mat-form-field appearance="outline" *ngIf="!field.multiline">
        <mat-label>{{field.label}} {{field.required ? '*':''}}</mat-label>
        <ng-container *ngIf="field && field.click">
        <input matInput [attr.type]="field.type" [id]="field.name" [name]="field.name" [formControlName]="field.name"  [placeholder]="field.placeholder" (click)="field.click($event)">
        </ng-container>
        <ng-container *ngIf="field && !field.click ">
        <input matInput [attr.type]="field.type" [id]="field.name" [name]="field.name" [formControlName]="field.name" [placeholder]="field.placeholder" [value]="field.value">
        </ng-container>
        <mat-hint *ngIf="field && field.hint">{{field.hint}}</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline"  *ngIf="field.multiline">
      <mat-label>{{field.label}} {{field.required ? '*':''}}</mat-label>
      <textarea style="height: 30px;" [class.is-invalid]="isDirty && !isValid" [formControlName]="field.name" [id]="field.name"
      rows="9" [placeholder]="field.placeholder" matInput></textarea>
      </mat-form-field>
       
      </div>




    `
})
export class TextBoxComponent {
  // <input  [attr.type]="field.type" class="form-control"  [id]="field.name" [name]="field.name" [formControlName]="field.name">
    @Input() field: any = {};
    @Input() form: FormGroup;
    get isValid() { return this.form.controls[this.field.name].valid; }
    get isDirty() { return this.form.controls[this.field.name].dirty; }

}


// <mat-form-field appearance="outline"  *ngIf="field.multiline">
// <mat-label>{{field.label}} {{field.required ? '*':''}}</mat-label>
// <textarea style="height: 30px;" [class.is-invalid]="isDirty && !isValid" [formControlName]="field.name" [id]="field.name"
// rows="9" [placeholder]="field.placeholder" matInput></textarea>
// </mat-form-field>